import { useCallback } from 'react';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import BackIcon from '@mui/icons-material/ArrowBack';
import Toolbar from '@mui/material/Toolbar';
import { getRouteApi, useNavigate } from '@tanstack/react-router';

import { FormattedMessage, useIntl } from 'react-intl';
import Spacings from '~/modules/ui-kit/spacings';

import ContentView from '~/components/ContentView';
import DepotForm from '~/components/DepotForm';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import messages from './messages';
import { useCreateDepot } from '~/hooks/api/useCreateDepot';

const route = getRouteApi('/depots/new');

const DepotCreate = () => {
  const navigate = useNavigate();
  const search = route.useSearch();
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();

  const handleBackButton = useCallback(() => {
    navigate({ to: search.from || '/depots' });
  }, [navigate, search.from]);

  const depotCreateMutation = useCreateDepot({
    onSuccess: () => {
      showSnackbar({
        message: intl.formatMessage(messages.saveSuccess),
      });
      handleBackButton();
    },
    onError: () => {
      showSnackbar({
        message: intl.formatMessage(messages.saveFailure),
      });
    },
  });

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <Spacings.Inline alignItems="center">
              <IconButton
                color="inherit"
                onClick={handleBackButton}
                size="large"
              >
                <BackIcon data-testid="back" />
              </IconButton>
              <div>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'inherit',
                  }}
                >
                  <FormattedMessage {...messages.title} />
                </Typography>
              </div>
            </Spacings.Inline>
          </Toolbar>
        </AppBar>
      }
    >
      <DepotForm onSubmit={depotCreateMutation.mutate} />
    </ContentView>
  );
};

export default DepotCreate;
